import { useEffect, useRef, useState } from "react";

import api from "@helpers/api";
import { adaptMyEnrollmentListItem } from "@pages/Mentoring/helpers/apiAdapters";

// The community being configured here can ALSO be a mentored creator in another
// owner's program. Surface only running participations (active mentoring or a
// split still in effect) — terminal/ended ones aren't actionable shortcuts.
// awaiting_community/pending never have a community attached, so the community
// filter excludes them naturally.
const RUNNING_STATUSES = new Set(["active", "split_only"]);

/**
 * "My mentorings" scoped to a single community: the creator's enrollments whose
 * attached community is `communityId`. Used by the Mentoria settings tab to show
 * a shortcut card to the enrollment detail (§6.11) when the community is itself
 * being mentored. A request stale-guard drops late responses; renders nothing
 * while loading (no skeleton — same as the sidebar shortcut).
 */
export default function useCommunityCreatorMentorings(communityId) {
  const [mentorings, setMentorings] = useState([]);
  const [loading, setLoading] = useState(true);

  const requestRef = useRef(0);

  useEffect(() => {
    if (!communityId) {
      setMentorings([]);
      setLoading(false);
      return;
    }

    const requestId = ++requestRef.current;
    setLoading(true);

    (async () => {
      const res = await api.get("mentoring/my-enrollments", { per_page: 50 });
      if (requestId !== requestRef.current) return;

      const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
      setMentorings(
        rows
          .filter(
            (e) =>
              RUNNING_STATUSES.has(e.status) &&
              String(e.community?.id) === String(communityId),
          )
          .map(adaptMyEnrollmentListItem),
      );
      setLoading(false);
    })();
  }, [communityId]);

  return { mentorings, loading };
}
